import React from 'react';
import ReactDOM from 'react-dom';
import { QuoteData } from '../../utils/pricingCalculator';
import QuoteGenerator from './QuoteGenerator';
import './Quote.css';

interface QuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  quoteData: QuoteData;
}

const QuoteModal: React.FC<QuoteModalProps> = ({ isOpen, onClose, quoteData }) => {
  if (!isOpen) return null;

  const handlePrint = () => {
    // Set document title for PDF filename
    const originalTitle = document.title;
    const customerName = quoteData.customerName.replace(/[^a-zA-Z0-9]/g, '_');
    const date = new Date().toISOString().split('T')[0];
    document.title = `Quotation_${customerName}_${date}`;
    
    window.print();
    
    // Restore original title after print
    setTimeout(() => {
      document.title = originalTitle;
    }, 1000);
  };

  const handleDownload = () => {
    // Set document title for PDF filename
    const originalTitle = document.title;
    const customerName = quoteData.customerName.replace(/[^a-zA-Z0-9]/g, '_');
    const date = new Date().toISOString().split('T')[0];
    document.title = `Quotation_${customerName}_${date}`;
    
    window.print();
    
    // Restore original title after print
    setTimeout(() => {
      document.title = originalTitle;
    }, 1000);
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {/* Modal Backdrop */}
      <div className="quote-modal-backdrop" onClick={handleBackdropClick}>
        <div className="quote-modal">
          {/* Modal Header */}
          <div className="quote-modal-header">
            <h2>Generated Quotation</h2>
            <div className="quote-modal-actions">
              <button
                onClick={handlePrint}
                className="quote-action-btn print-btn"
                title="Print Quotation"
              >
                <span className="btn-icon">🖨️</span>
                Print
              </button>
              <button
                onClick={handleDownload}
                className="quote-action-btn download-btn"
                title="Download as PDF"
              >
                <span className="btn-icon">📄</span>
                Save PDF
              </button>
              <button
                onClick={onClose}
                className="quote-action-btn close-btn"
                title="Close"
              >
                <span className="btn-icon">✕</span>
                Close
              </button>
            </div>
          </div>

          {/* Modal Content */}
          <div className="quote-modal-content">
            <QuoteGenerator quoteData={quoteData} />
          </div>
        </div>
      </div>

      {/* Print-only version (hidden on screen) - Rendered to body using Portal */}
      {ReactDOM.createPortal(
        <div className="quote-print-version">
          <QuoteGenerator quoteData={quoteData} />
        </div>,
        document.body
      )}
    </>
  );
};

export default QuoteModal;